import { useEffect, type RefObject } from "react";

/** Reveal selection within its strip without scrolling the page vertically. */
export function useHorizontalSelection(ref: RefObject<HTMLElement | null>, selection: string) {
  useEffect(() => {
    const strip = ref.current;
    if (!strip) return;
    const reveal = () => {
      const selected = strip.querySelector<HTMLElement>('[aria-selected="true"], [aria-current="page"]');
      if (!selected) return;
      const viewport = strip.getBoundingClientRect();
      const item = selected.getBoundingClientRect();
      if (item.left < viewport.left) strip.scrollLeft += item.left - viewport.left;
      else if (item.right > viewport.right) strip.scrollLeft += item.right - viewport.right;
    };
    reveal();
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(reveal);
    observer?.observe(strip);
    return () => observer?.disconnect();
  }, [ref, selection]);
}
